module.exports = __webpack_public_path__ + "img/gamesdk23.16588df.png";